import React from 'react';
import { PrimaryButton } from 'src/shared/design-system/Buttons';
import { StyledButtonProps } from './types';

export const StyledButton: React.FC<React.PropsWithChildren<StyledButtonProps>> = (props) => (
  <PrimaryButton {...props} />
);
